import {DomainEvent} from './DomainEvent';
import {DeletedEntity} from '../resources/DeletedEntity';

export class ProfileDeleted extends DomainEvent<DeletedEntity> {}
